// extracted by mini-css-extract-plugin
export default {"authbox":"authbox_authbox__QdXBT","slideTopIn":"authbox_slideTopIn__MyEAa"};